export interface RetailerProps {
  retailerId: number | null;
  retailerKey: string | null;
  retailerName: string | null;
}

export class Retailer {
  private readonly _retailerId: number | null;
  private readonly _retailerKey: string | null;
  private readonly _retailerName: string | null;

  constructor(props: RetailerProps) {
    this._retailerId = props.retailerId;
    this._retailerKey = props.retailerKey;
    this._retailerName = props.retailerName;
  }

  public get retailerId(): number | null {
    return this._retailerId;
  }

  public get retailerKey(): string | null {
    return this._retailerKey;
  }

  public get retailerName(): string | null {
    return this._retailerName;
  }
}

